import React, { useState, useEffect } from 'react';

const streamerRage = [
  "https://media.tenor.com/0M5L_9AhFgwAAAAM/jessicasprings0-xqc-rage.gif",
  "https://media.tenor.com/K1J-zVJRKnsAAAAM/xqc-slam.gif",
  "https://media.tenor.com/MOdyGfofDyoAAAAM/xqc-smash.gif",
  "https://media.tenor.com/4u_4kga0YBYAAAAM/esports-game.gif",
  "https://media.tenor.com/L9cvhVRnl_sAAAAM/rage-quit.gif",
  "https://media.tenor.com/4brNhbH7oZcAAAAM/ninja-ninja-rage.gif",
  "https://media.tenor.com/L1EHEx48tOEAAAAM/tyler1-screaming.gif",
  "https://media.tenor.com/pmxj_v8saOMAAAAM/loltyler1-gamer-rage.gif",
  "https://media.tenor.com/1kQeLdVWNmoAAAAM/streamer-mad.gif",
  "https://www.icegif.com/wp-content/uploads/2024/05/caseoh-icegif-6.gif",
  "https://media.tenor.com/kC8C7bAzqZkAAAAM/kai-cenat-kai.gif",
];

const emotes = require('./emotes2.json');

function getRandomEmote(exclude) {
  const pool = exclude ? emotes.filter(e => e.id !== exclude.id) : emotes;
  return pool[Math.floor(Math.random() * pool.length)];
}

export default function App() {
  
  const [score, setScore] = useState(0);
  const [current, setCurrent] = useState(() => getRandomEmote());
  const [next, setNext] = useState(() => getRandomEmote(current));
  const [gameStage, setGameStage] = useState('playing'); // 'playing', 'revealing', 'animating', 'gameover'
  const [nextAmount, setNextAmount] = useState(0); 
  // Controls our two-part transition: "none" | "slide" | "fade"
  const [transitionPhase, setTransitionPhase] = useState("none");
  // Used to trigger fade-in class after updating next emote
  const [fadeActive, setFadeActive] = useState(false);

  useEffect(() => {
    if (transitionPhase === "fade") {
      // trigger fade-in after a short delay to ensure CSS transitions are applied
      setTimeout(() => {
        setFadeActive(true);
      }, 50);
    }
  }, [transitionPhase]);

  const playNextAmount = (number, animationTime = 800) => {
    if (number < nextAmount) {
      setNextAmount(number);
      return;
    }
    const startValue = nextAmount;
    const change = number - startValue;
    const startTime = performance.now();

    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / animationTime, 1);
      const newValue = Math.floor(startValue + change * progress);
      setNextAmount(newValue);
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }
    requestAnimationFrame(animate);
  };

  const handleGuess = (isHigher) => {
    if (gameStage !== 'playing') return;
    setGameStage('revealing');

    playNextAmount(next.amount, 800);
    const correct = isHigher
      ? next.amount >= current.amount
      : next.amount <= current.amount;

    if (correct) {
      // Let the number animation finish then start slide animation (2 sec delay)
      setTimeout(() => {
        setGameStage('animating');
        setTransitionPhase("slide");
      }, 2000);
    } else {
      setTimeout(() => {
        setGameStage('gameover');
      }, 2000);
    }
  };

  const resetGame = () => {
    const first = getRandomEmote();
    setScore(0);
    setCurrent(first);
    setNext(getRandomEmote(first));
    setGameStage('playing');
    setTransitionPhase("none");
    setFadeActive(false);
    setNextAmount(0);
  };

  const getRandomStreamerRage = () => {
    const randomIndex = Math.floor(Math.random() * streamerRage.length);
    return streamerRage[randomIndex];
  };

  // Called when the transition animation (slide or fade) completes
  const handleNextPanelTransitionEnd = (e) => {
    if(e.propertyName === 'transform' && transitionPhase === 'slide'){
      // Slide finished: update current & load a new next emote
      setCurrent(next);
      setNext(getRandomEmote(next));
      setNextAmount(0);
      setFadeActive(false);
      setTransitionPhase("fade");
      // Also update score here
      setScore(prev => prev + 1);
    }
    else if(e.propertyName === 'opacity' && transitionPhase === 'fade'){
      // Fade finished; animation complete.
      setTransitionPhase("none");
      setGameStage("playing");
    }
  };

  const scorePercentage = (score) => {
    // top 1% = 100, top 5% = 20, top 10% = 10, top 20% = 5, top 50% = 2
    // so below is a formula to calculate the percentage
    return Math.max(1, Math.floor(100 - (score ** 1.75)));
  }

  if (gameStage === 'gameover') {
    return (
      <div className='red'>
        <div className='gameover-screen' style={{
          backgroundImage: `url(${getRandomStreamerRage()})`,
          backgroundSize: 'cover',
          animation: 'fadeIn 0.25s ease-in forwards',
        }}>
        <h1>Game Over</h1>
        <p className='score'>Your score: {score}</p>
        <p className='score sub'>
          <p>You lost to <b>{current.emote}</b> and <b>{next.emote}</b>.</p>
          <p>This places you in the top <b>{scorePercentage(score)}%</b> of chatters.</p>
        </p>
        <button onClick={resetGame} className='button playagain'>Play Again</button>
        </div>
      </div>
    );
  }

  const cleanType = (type) => {
    if (type === 'sevenTVEmotes') return '7TV';
    if (type === 'bttvEmotes') return 'BTTV';
    if (type === 'ffzEmotes') return 'FFZ';
    if (type === 'twitchEmotes') return 'Twitch';
    return type.charAt(0).toUpperCase() + type.slice(1);
  }

  return (
    <div>
      <div className="center" style={{
          backgroundColor: gameStage === 'animating' ? '#93C572' :
                 gameStage === 'gameover' ? 'red' : 'white'
        }}>
        <div>
          {gameStage === 'playing' || gameStage === 'revealing'
            ? "VS"
            : gameStage === 'animating'
            ? "🎉"
            : gameStage === 'gameover'
            ? "❌"
            : ""}
        </div>
      </div>
      <div className="header">
        <div className='logo'>TTV Emotes Higher or Lower</div>
        <div className="score">Score: {score}</div>
      </div>
      <div className="game-container" style={{ position: 'relative' }}>
        <div className="panel left">
          <img
            src={current.url}
            alt={current.emote}
            className="emote-img"
            onError={(e) => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/150'; }}
          />
          <p className='emote-name'>{current.emote} ({cleanType(current.type)})</p>
          <div className="count">{current.amount.toLocaleString()}</div>
          <div className="count-subtitle">total uses on Twitch.TV</div>
          <div className="controls hidden">
            <button onClick={() => handleGuess(true)} className="button higher">Higher</button>
            <button onClick={() => handleGuess(false)} className="button lower">Lower</button>
          </div>
        </div>
        <div
          className={
            "panel right" +
            (transitionPhase === "slide" ? " slide" : "") +
            (transitionPhase === "fade" ? (fadeActive ? " fade fade-active" : " fade") : "")
          }
          onTransitionEnd={handleNextPanelTransitionEnd}
          style={{ position: 'relative' }}
        >
          <img
            src={next.url}
            alt={next.emote}
            onError={(e) => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/150'; }}
            className={`emote-img ${next.url === current.url ? 'hidden' : 'visible'}`}
          />
          <p className='emote-name'>{next.emote} ({cleanType(current.type)})</p>
          <div className="count">
            { nextAmount === 0 ? <>&nbsp;</> : nextAmount.toLocaleString() }
          </div>
          <div className="count-subtitle">
            { nextAmount === 0 ? <>&nbsp;</> : "total uses on Twitch.TV" }
          </div>
          <div className={`controls animate-hiding ${gameStage === 'playing' ? '' : 'hidden'}`}>
            <button onClick={() => handleGuess(true)} className="button higher">Higher</button>
            <button onClick={() => handleGuess(false)} className="button lower">Lower</button>
          </div>
        </div>
      </div>
    </div>
  );
}
